/* unplugin-vue-components disabled */import { render } from "./PriceCalculateImage.vue?vue&type=template&id=c4b1c72c&scoped=true"
import script from "./PriceCalculateImage.vue?vue&type=script&lang=js"
export * from "./PriceCalculateImage.vue?vue&type=script&lang=js"

import "./PriceCalculateImage.vue?vue&type=style&index=0&id=c4b1c72c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b1c72c"]])

export default __exports__